<template>
  <div class="modal__warning-container">
    <img
      src="@/assets/icons/close.svg"
      alt="Botão de fechar"
      class="button-close"
      @click="close"
    >
    <h1 class="title">
      Tudo certo!
    </h1>
    <p class="description">
      Cadastro enviado para aprovação
    </p>
  </div>
</template>

<script>
export default {
    name: "Warning",
    methods: {
        close() {
            this.$emit('close')
        },
        verifyClose(event) {
            if(event.target === event.currentTarget)
            this.$emit("close")
        },
    }
}
</script>

<style lang="scss" scoped>
.modal__warning-container {
  background: white;
  position: relative;
  padding: 30px 60px;

  .button-close {
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .title {
    margin-bottom: 20px;
  }
}
</style>